






























































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'SpaceCard'

  vue:
    props: ['item', 'actions', 'options']

    components: {
      LoadingIndicator,
    }

    computed:
      editable: ->
        return @options.editable if @options?.editable?
        true

      tags: ->
        tags = []
        tags.push { value: 'assembly', label: 'Assembly' } if @item.services.can_assemble_items
        tags.push { value: 'serve_cold', label: 'Serve Cold' } if @item.services.can_serve_cold
        tags

    methods:
      hiNavToDetails: ->
        @$router.push { name: 'SpaceShowPage', params: { spaceId: @item.id } }

      hiNavToEdit: ->
        name = 'SamplingSpaceEditPage' if @item.type is 'product_sampling'
        name ||= 'OmnichannelSpaceEditPage' if @item.type is 'omnichannel'
        name ||= 'OnsiteSpaceEditPage'
        supplierId = @item.top_org_id
        spaceId = @item.segment if @item.type is 'onsite_space'
        spaceId ||= @item.id
        @$router.push { name, params: { spaceId }, query: { step: 'setup', supplierId } }

export default VueOptions.vue settings
